import React from 'react';
import get from 'lodash/get';
import moment from 'moment';
import styled from 'styled-components';
import StyledCheckbox from '../checkbox/StyledCheckbox';
import StyledRadioButton from '../radio/StyledRadioButton';

const TableBody = ({
  data,
  columns,
  selectedRows,
  checkBox,
  ref,
  loading,
  contentLoading = false,
  handleRowClick,
  formListings,
  setSelectedRows
}) => {
  const renderCell = (item, column) => {
    if (column.content) return column.content(item, contentLoading);
    if (column.path === 'createdAt' || column.path === 'updatedAt') {
      return formatDate(get(item, column.path));
    }
    return get(item, column.path) ?? '-';
  };

  const createKey = (item, column) => {
    // return (item?.id || 1) + (column?.path || column?.key) + Math.random();
    return `${item.id}-${column.content || column.path}`;
  };
  const formatDate = (date) => moment(new Date(date)).format('Do MMM YYYY');
  const totalRows  = data?.length; // Check if the row is the last one
  return (
    <StyledTBody ref={ref}>
      {data?.map((item, index) => (
        <tr key={`row-${index}`} ref={ref}>
          {checkBox && (
            <td ref={ref} className='align-middle'>
              {formListings ? (
                <StyledRadioButtonWrap>
                  <StyledRadioButton
                    title={'false'}
                    size="12"
                    className="ms-1 mt-1 me-0"
                    value={selectedRows?.includes(item?.id)? true: false}
                    type ={'documentstyles'} 
                    disabled={false}
                    onChange={() => setSelectedRows(selectedRows?.includes(item?.id)?[]:[item?.id])}
                  />
                </StyledRadioButtonWrap>
              ) : (
                <StyledCheckbox
                  className={`ms-2 mt-2 me-2 ${(item?.GDPRDeleted || item._source?.candidateStatus === 44) ? 'pe-none' : ''}`}
                  size={15}
                  value={selectedRows?.includes(item)}
                  onChange={() => {
                    handleRowClick(item);
                  }}
                />
              )}
            </td>
          )}

          {columns?.map((column) => (
            <td key={createKey(item, column)} className={` ${column.alignBody} ${index >= totalRows - 3 ? "last-row" : ""}`} >
              {renderCell(item, column)}
            </td>
          ))}
        </tr>
      ))}
    </StyledTBody>
  );
};

const StyledTBody = styled.tbody`
  tr:last-child > td {
    border-bottom: 0;
  }
`;

const StyledRadioButtonWrap= styled.div`
&>label{
margin-right: 0px !important;
}
`

export default TableBody;
